import React from "react";
import { Flame, Play } from "lucide-react";

// Right-hand column: "power feature" promo card
export default function SideCards() {
  return (
    <aside className="sidebar">
      <div className="card feature-card">
        <div className="feature-preview">
          <div className="play-button">
            <Play size={18} fill="#ffffff" />
          </div>
        </div>
        <div className="feature-content">
          <div className="badge badge-success mb-2">
            <Flame size={12} /> Power Feature
          </div>
          <h6 className="fw-bold mb-1">Stock Alerts</h6>
          <p className="small text-muted mb-0">
            Get notified if the price reaches your buy zone. Even after years. Set and forget.
          </p>
        </div>
      </div>
    </aside>
  );
}